<div [class]="headerSticky ? 'theme-main-menu sticky-menu theme-menu-four bg-none fixed'
: 'theme-main-menu sticky-menu theme-menu-four bg-none' ">
  <div class="d-flex align-items-center justify-content-between">
    <div class="logo"><a [routerLink]="['/']">
      <img src="assets/images/logo/deski_05.svg" alt=""></a>
    </div>
    <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
      <div  class="nav-container">
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
            [ngClass]="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" (click)="handleNavToggle()">
            <span></span>
        </button>
         <div class="navbar-collapse collapse" id="collapsibleNavbar">
             <div class="d-lg-flex align-items-center">
              <!-- nav menu start -->
              <app-nav-menu></app-nav-menu>
              <!-- nav menu end -->
            <ul class="right-button-group d-flex align-items-center justify-content-center">
                 <li>
                <a [routerLink]="['/login']" class="signIn-action">Login</a>
              </li>
              <li>
                <a [routerLink]="['/register']" class="theme-btn-five">Create your event</a>
              </li>
            </ul>
             </div>
           </div>
      </div>
    </nav>
  </div>
</div>
